import { LeadStageEnum } from "../enums/lead-stage.enum";

export const LeadStageLabel: Record<LeadStageEnum, string> = {
  [LeadStageEnum.UNREAD]: "Unread",
  [LeadStageEnum.IN_PROGRESS]: "In Progress",
  [LeadStageEnum.BUSINESS]: "Business",
  [LeadStageEnum.NO_BUSINESS]: "No Business",
  [LeadStageEnum.DUPLICATE]: "Duplicate",
};
